export const namespace = 'packageReturns';

export const MutationTypes = {
  SET_PACKAGE_RETURNS: 'SET_PACKAGE_RETURNS',
  SET_PACKAGE_RETURN: 'SET_PACKAGE_RETURN',
};

export const ActionTypes = {
  GET_PACKAGE_RETURNS: 'GET_PACKAGE_RETURNS',
  GET_PACKAGE_RETURN: 'GET_PACKAGE_RETURN',
};
